<template>
    <div id="map3" class="w-100 h-100"></div>
</template>

<script>
export default {
    props: {
        clearArea: {
            type: Boolean,
            required: true
        },
        size: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            map: null,
            currentMarker: null,
            currentCircle: null,
        };
    },
    mounted() {
        setTimeout(function () {
            this.initializeMap();
        }.bind(this), 1000);
    },
    watch: {
        clearArea(newValue) {
            if (newValue) {
                this.clearMapLayers();
            }
        },
        size(newValue) {
            let newSize = newValue * 1000;
            console.log(newSize);
            if (this.currentCircle) {
                this.currentCircle.setRadius(newSize);
                this.$emit('Area', this.currentCircle.getBounds());
            }
        }
    },
    methods: {
        // Initialize the map
        initializeMap() {
            if (this.map) {
                return;
            }
            this.map = L.map('map3', {
                attributionControl: false,
                zoomControl: false
            }).setView([50.1003, 14.2555], 11);

            L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', {
                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
                maxZoom: 15
            }).addTo(this.map);

            // Add click event to map
            this.map.on('click', this.addMarkerWithCircle);
        },

        // Add a marker with a circle at the clicked location
        addMarkerWithCircle(event) {
            const latlng = event.latlng;

            // If there's an existing marker and circle, remove it
            if (this.currentMarker) {
                this.map.removeLayer(this.currentMarker);
                this.map.removeLayer(this.currentCircle);
            }

            this.currentMarker = L.marker(latlng, {
            }).addTo(this.map);
            this.currentCircle = L.circle(latlng, {
                color: 'purple',
                fillColor: 'purple',
                fillOpacity: 0.1,
                radius: this.size
            }).addTo(this.map);

            // Emit the area to the parent component
            this.$emit('Area', this.currentCircle.getBounds());
        },
        clearMapLayers() {
            if (this.currentMarker) {
                this.map.removeLayer(this.currentMarker);
                this.currentMarker = null;
            }
            if (this.currentCircle) {
                this.map.removeLayer(this.currentCircle);
                this.currentCircle = null;
            }
            this.$emit('areaCleared');
        },
    }
};
</script>

<style scoped lang="scss"></style>